<template>
    <transition name="bounce">
        <div class="container w-736 mt-4 utm-banner-contain" v-if="display" @click="redirectUrl">
            <img class="utm-banner-img d-none d-md-block" :src="imageUrlDesktop" />
            <img class="utm-banner-img mobile-ver d-block d-md-none" :src="imageUrlMobile" />
            <span class="utm-banner-text">{{lineText}}</span>
            <a class="utm-banner-close" @click.stop="displayBanner(0)"><img src="/assets/images/utm-close.png"></a>
        </div>
    </transition>
</template>

<script>
import {getUtmBannerRegister} from '../module/cms';

/**
 * Sử dụng cho hiển thị banner line text ở trang đăng ký của các dịch vụ
 * HOT T1-#09
 * @since Jan, 2024
 * @author DaiDP
 */
export default {
    props: {
        serviceCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            display: 0,
            imageUrlDesktop: "",
            imageUrlMobile: "",
            lineText: "",
            linkClick: "",
            dataQuery: {}
        };
    },
    created() {
        // Khôi phục trạng thái từ local storage khi ứng dụng được tải
        this.$store.commit('core_utmRegister/restoreState');
    },
    mounted() {
        // Lưu vào vuex khi url có UTM param
        if (this.$route.query?.utm_source)
        {
            this.$store.commit('core_utmRegister/setUtm', {
                service_code: this.serviceCode,
                data_query: this.$route.query
            });
        }

        // Lấy dữ liệu utm từ vuex
        //this.dataQuery = this.$store.state.core_utmRegister.utm[this.serviceCode] || {};
        this.dataQuery = this.$store.state.core_utmRegister.utm.line_text || {};

        // Gọi api lấy cấu hình để hiển thị
        this.getConfig();
    },

    methods: {
        /**
         * Quản lý việc hiển thị banner
         * @param integer display
         */
        displayBanner(display) {
            this.display = display;
        },
        getConfig() {
            // Không có giá trị thì khỏi xử lý
            if (!this.dataQuery.utm_source || !this.dataQuery.utm_medium) {
                //return;
            }
            // Gọi API lấy cấu hình
            getUtmBannerRegister(this.callbackListPost, {
                service_code: this.serviceCode,
                utm_source: this.dataQuery.utm_source,
                utm_medium: this.dataQuery.utm_medium
            });
        },
        callbackListPost(isSuccess, respData, error) {
            // Không có dữ liệu thì bỏ qua
            if (! isSuccess || respData?.error) {
                return;
            }

            // Không có cấu hình thì ngưng xử lý
            if (respData.data.display != 1) {
                return;
            }

            // Xử lý hiển thị
            this.imageUrlDesktop = respData.data.config.img_path;
            this.imageUrlMobile = respData.data.config.img_path_mobile;
            this.lineText = respData.data.config.description;
            this.linkClick = respData.data.config.utm_url;
            let o =this;
            setTimeout(function() {
                o.displayBanner(1);
            }, 4500);
        },
        redirectUrl() {
            if (! this.linkClick || this.linkClick.trim() == '') {
                return;
            }

            window.location = this.linkClick;
        }
    },
};
</script>
